import httpClient from './api/httpClient';
import PreMatricula from '@/models/prematricula'
import RascunhoItem from '@/models/rascunhoItem'

const END_POINT = 'prematricula';
export const get = (id) => httpClient.get(END_POINT + '/' + id)
    .then((res) => {
        return Promise.resolve(getPrematriculaFromData(res.data));
    })

export const getOne = () => httpClient.get(END_POINT + '/')
    .then((res) => {
        return Promise.resolve(getPrematriculaFromData(res.data));
    })

export const salvarStatusRegistroPreMatricula = (idPrematricula, novoStatusRegistro) =>
{   
    return httpClient.post(END_POINT + '/salvarStatusRegistro/'+idPrematricula+'/'+novoStatusRegistro);  
}

export const finalizar = () => httpClient.post(END_POINT + '/finalizar');

export const finalizarParecer = (itemRascunho) => {
    let rascunhoForm = {
        'id': itemRascunho.id,
        'texto': itemRascunho.texto,
        'tipo': itemRascunho.tipo.codigo,
        'idItemRelacionado': itemRascunho.idItemRelacionado,
        'situacao': itemRascunho.situacao,
        'dataLimiteRecurso': itemRascunho.dataLimiteRecurso
    }
    return httpClient.post(END_POINT + '/itens/finalizar', rascunhoForm);
}

export const salvarRecurso = (recurso) => {
    let formData = new FormData();
    formData.append('texto', recurso.texto);
    formData.append('idParecer', recurso.parecer.id);
    if (Array.isArray(recurso.anexos) && recurso.anexos.length > 0)
        recurso.anexos.forEach(file => formData.append('anexos',file));
    return httpClient.post(END_POINT + "/recursos/salvar", formData);
}

export const getRascunhoAnalise = (idAnalise) => httpClient.get(END_POINT + "/analises/" + idAnalise + "/rascunho")
    .then((res) => {
        let rascunho = new RascunhoItem(
            res.data.id, 
            res.data.texto, 
            res.data.situacao, 
            res.data.dataLimiteRecurso,
            res.data.tipo, 
            res.data.idItemRelacionado, 
            res.data.arquivos, 
            res.data.status);
        return Promise.resolve(rascunho);
    })

export const salvarRascunho = (itemRascunho) => {
    let rascunhoForm = {
        'id': itemRascunho.id,
        'texto': itemRascunho.texto,
        'tipo': itemRascunho.tipo.codigo,
        'idItemRelacionado': itemRascunho.idItemRelacionado,
        'situacao': itemRascunho.situacao,
        'dataLimiteRecurso': itemRascunho.dataLimiteRecurso
    }
    return httpClient.patch(END_POINT + "/itens/rascunho/" + itemRascunho.id, rascunhoForm);
}

export const getPendenciasInscricao = () => httpClient.get(END_POINT + '/pendencias-inscricao');
export const getStatusCandidato = () => httpClient.get(END_POINT + '/status-candidato');

const getPrematriculaFromData = (data) => {
    return new PreMatricula(
        data.id,
        data.candidato,
        data.documentos,
        data.analises,
        data.status,
        data.historico,
        data.pendenciasInscricao,
        data.statusRegistroMatricula,
    );
}

export const excluirUltimoItem = (idAnalise) => {    
    return httpClient.get(END_POINT + "/excluirUltimoItemAnalise/" + idAnalise);
}

